import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import Menu from 'next/javascripts/components/menu';

Component('tr-header-help-menu', {
  extends: [Menu],

  mixins: [eventListenerMixin],

  properties: {
    featureKey: String,
  },

  connected() {
    if (this.featureKey) {
      this.listenTo(this.querySelector('#link-roadmap'), 'click', () => {
        $.post('/new_feature_confirmations', {
          metadata_key: `${this.featureKey}_shown`,
        }).then(() => this.removeAttribute('feature-key'));
      });
    }
  },
});
